<template>
    <ValidationObserver v-slot="{ handleSubmit, invalid }">
        <b-form @submit.prevent="handleSubmit(updatePriceListData)">  
            <b-card header-tag="header" footer-tag="footer" class="mt-8 mb-8">
                <template v-slot:header>
                    <p class="mb-0" style="font-size: 21px">Actualizar Lista de Precio</p>
                </template>
                <b-card-text>
                    <b-alert show variant="danger" v-if="errors">
                        <ul >
                            <li v-for="(item, index) in errors" :key="index">{{ item }}</li>
                        </ul>
                    </b-alert>
                    <b-tabs content-class="mt-3" justified>
                        <b-tab title="Información Básica" active>
                            <b-row> 
                                <b-col cols="12" md="6">
                                    <ValidationProvider name="codigo" rules="required|min:1" v-slot="{ errors, valid }">
                                        <b-form-group 
                                            label="Código:">
                                            <b-form-input
                                                v-model="updatePriceList.codigo"
                                                type="text"
                                                autocomplete="off"
                                                required
                                                :readonly="isPrimary === 1"
                                                :state="errors[0] ? false : (valid ? true : null)"
                                                placeholder="Ingrese el código"
                                                ></b-form-input>
                                            <b-form-invalid-feedback>
                                                {{ errors[0] }}
                                            </b-form-invalid-feedback>
                                        </b-form-group>
                                    </ValidationProvider>
                                </b-col>
                                <b-col cols="12" md="6">
                                    <ValidationProvider name="nombre" rules="required|min:3" v-slot="{ errors, valid }">
                                        <b-form-group 
                                            label="Nombre:">
                                            <b-form-input
                                                v-model="updatePriceList.nombre"
                                                type="text"
                                                autocomplete="off"
                                                required
                                                :readonly="isPrimary === 1"
                                                :state="errors[0] ? false : (valid ? true : null)"
                                                placeholder="Ingrese el nombre"
                                                ></b-form-input>
                                            <b-form-invalid-feedback>
                                                {{ errors[0] }}
                                            </b-form-invalid-feedback>
                                        </b-form-group>
                                    </ValidationProvider>
                                </b-col>
                                <b-col cols="12" md="6"  v-if="isPrimary !== 1">
                                    <b-form-group 
                                        label="Estado:"
                                        label-for="status">
                                        <b-row cl>
                                        <b-form-checkbox v-model="updatePriceList.status" name="status" switch class="ml-3" />
                                        <span v-if="updatePriceList.status === true">Activo</span>
                                        <span v-else>Inactivo</span>
                                        </b-row>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row v-if="isPrimary === 1">   
                                <p class="pl-4">Esta es la lista de precios principal, por tanto no puede ser modificada o inactivada.</p>
                            </b-row>
                        </b-tab>
                        <b-tab title="Items">
                            
                                <ItemsComponent 
                                    :items="items" 
                                    :paginator="paginator" 
                                    :pageSize="pageSize"  
                                    :idPricelist="$route.params.id"
                                    @get-price-list-data-empresa="getPriceListData()" 
                                    @change-page="changePage($event)"
                                />
                            
                        </b-tab>
                    </b-tabs>
                    
                </b-card-text>
                <template v-slot:footer>
                    <b-button variant="danger" class="mr-2" @click.prevent="back">
                        Cancelar
                    </b-button>
                    <b-button variant="success" class="mr-2" v-if="isPrimary != 1" :disabled="invalid" type="submit">
                        Actualizar
                    </b-button>
                    <b-button variant="info" @click.prevent="printWindow">
                        Imprimir
                    </b-button>
                </template>
            </b-card>
        </b-form>
    </ValidationObserver>
    
</template>

<script>
import { mapMutations } from 'vuex'
import ItemsComponent from '../components/ItemsComponent.vue'
export default {
    data(){
        return{
            errors: "",
            items: [],
            updatePriceList: {
                codigo: '',
                nombre: '',
                status: false
            },
            paginator: {
                page: 1,
                totalPage: 1,
                pageSize: 10,
            },
            pageSize: [10, 25, 50, 100],
            isPrimary: 0,
            updatePriceModal: false,
            updatePriceData: {},
            pageOptions: {}
        }
    },
     created(){
        this.getPriceListData();
    },
    components:{
        ItemsComponent
    },
    methods:{
        ...mapMutations(['setLoading']),
        async getPriceListData(){
            this.setLoading(true)
            this.pageOptions = {
                priceListId: this.$route.params.id,
                pageNumber: this.paginator.page, 
                pageSize: this.paginator.pageSize,
            }
            await this.$conectar.post('/empresa/price-list/get-price-list-data-empresa', this.pageOptions)
            .then(response =>{
                this.updatePriceList = response.data.price_list_data;
                this.paginator.totalPage = response.data.totalPages;
                this.items = response.data.price_list_data.items;
                if(response.data.price_list_data.isPrimary === 1){
                    this.isPrimary = 1;
                }
            })
            .catch(e => {
                console.log(e.response);
            })
            this.setLoading(false)
        },
        async updatePriceListData(){
            this.setLoading(true)
            this.errors = "";
            await this.$conectar.post('/empresa/price-list/save-price-list', this.updatePriceList)
            .then(response =>{
                if(response.data.errors){
                    this.errors = response.data.errors;
                }
                if(response.data.error === false){
                    this.$root.$bvToast.toast('Se actualizo correctamente la lista de precios', {
                            title: "Respuesta del servidor",
                            variant: "success",
                            solid: true
                    })
                    this.$router.push({ name: 'getPriceListEmpresa' });
                }
            })
            .catch(e => {
                console.log(e.response);
                this.$bvToast.toast('Parece que hubo un error en el servidor', {
                    title: "Respuesta del servidor",
                    variant: "danger",
                    solid: true
                })
            })
            this.setLoading(false)
        },
        back(){
            this.$router.go(-1);
        },
        changePage(page){
            this.paginator.page = page;
            this.getPriceListData();
        },
        printWindow() {
            window.print();
        }

        
    }
}
</script>